import React from "react";
import { getDate } from "utils/formatDate";
import Pagination from "react-js-pagination";

class LichSuGiaHanView extends React.Component {
  constructor(props) {
    super(props);
    let isShow = true;
    let displayText = "contents";
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = !mq.matches;
      if (mq.matches) displayText = "block";
    }
    this.state = {
      text1: "",
      itemShow: {
        item: null,
        isShow: isShow,
        displayText,
      },
    };
  }
  showRow = (item) => () => {
    let { itemShow } = this.state;
    let isShow = true;
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = mq.matches && !itemShow.isShow;
    }
    itemShow.item = item;
    itemShow.isShow = isShow;
    this.setState({ itemShow });
  };
  renderRow(List) {
    let { pageIndex, pageSize } = this.props;
    return List.map((item, index) => {
      let { Time, SoLan, Note } = item;
      return (
        <tr className="" key={"lsGiaHan" + index}>
          <td style={{width:"10%"}}>{index + 1 + (pageIndex - 1) * pageSize}</td>
          <td className="text-center" style={{width:"30%"}}>{getDate(Time)}</td>
          <td className="text-center" style={{width:"20%"}}>{SoLan}</td>
          <td className="text-left" style={{width:"40%"}}>{Note}</td>
        </tr>
      );
    });
  }
  render() {
    let {
      List,
      pageIndex,
      pageSize,
      TotalQuantity,
      handlePageChange,
    } = this.props;
    return (
      <div className="table-from-detailtl3">
        <div className="Left808x200  Table-main-morman table-noboder-new">
          <div className="table-responsive table-new1">
            <table className="table table-bordered table-hover table-rounded"  style={{marginTop:"20px"}}>
              <thead>
                <tr>
                  <th className="w-stt"><span className="color-do-bold">[{TotalQuantity}]</span></th>
                  <th className="w-10" style={{width:"30%"}}>Ngày gia hạn</th>
                  <th className="w-stt"  style={{width:"20%"}}>Số lần thêm</th>
                  <th className="text-left" style={{width:"40%"}}>Lí do gia hạn</th>
                </tr>
              </thead>
              <tbody>{this.renderRow(List)}</tbody>
            </table>
          </div>
        </div>
        {TotalQuantity > pageSize && (
          <div className="footer-page-new">
            <div className="col-xl-12 col-lg-12">
              <div class="paniation-new d-flex just-end">
                <nav aria-label="Page navigation">
                  <Pagination
                    activePage={pageIndex}
                    itemsCountPerPage={pageSize}
                    totalItemsCount={TotalQuantity}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item border-none"
                    linkClass="page-link border-none"
                    activeClass="active"
                  />
                </nav>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default LichSuGiaHanView;
